// extracted by mini-css-extract-plugin
export default {"item":"Location_item__R+T3l","list":"Location_list__6EOq4","col":"Location_col__6mE6b"};